import React from 'react';

import {
  AppBar as MuiAppBar,
  Box,
  IconButton,
  styled,
  Toolbar as MuiToolbar
} from '@mui/material';
import {
  authService,
  OptionsPopover
} from 'iron-forge-react-modules';
import {
  permissionUtil,
  routeDirectory,
  StoreThemeProvider
} from 'modules/layer00';
import {
  Logout,
  MoreVert,
  Settings
} from '@mui/icons-material';

import { useNavigate } from 'react-router-dom';
import * as BaseActivityTemplate from '../BaseActivityTemplate/BaseActivityTemplate';
import * as dataService from './dataService';



const AppBar = styled(MuiAppBar)(() => ({
}));

const Toolbar = styled(MuiToolbar)(() => ({
  backgroundColor: 'white',
  justifyContent: 'space-between',
  display: 'flex',
  position: 'relative'
}));

const ChildBox = styled(Box)(({ theme }) => ({
  boxSizing: 'border-box',
  // Sometimes 56, sometimes 64
  height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px - ${theme.spacing(1)})`
}));

const LeftContentBox = styled(Box)({
  flexGrow: 1
});

const RightContentBox = styled(Box)({
  display: 'flex',
  alignItems: 'center'
});

const LogoBox = styled(Box)({
  position: 'absolute',
  transform: 'translate(-50%)',
  left: '50%',
  '& img': {
    maxHeight: '30px'
  }
});



export interface IProps {
  children: React.ReactNode | React.ReactNode[];

  elLeftContent?: JSX.Element;
  elRightContent?: JSX.Element;
  storeId: string;
}

export const FC: React.FC<IProps> = props => {
  const navigate = useNavigate();
  const tuple = dataService.useQuery(props.storeId);
  const [hasPermission, loading] = permissionUtil.usePermissions({
    storeId: props.storeId,
    evaluationCriteria: 'all'
  });


  function handleClickOption(optionId: string) {
    if (optionId === 'logOut') {
      authService.logOut();
    } else if (optionId === 'settings') {
      navigate(routeDirectory.partner.storeSettings.path(props.storeId, 'base'));
    }
  }



  return (
    <StoreThemeProvider.FC storeId={props.storeId}>
      <BaseActivityTemplate.FC>
        <AppBar position="relative">
          <Toolbar>
            <LeftContentBox>
              {props.elLeftContent}
            </LeftContentBox>

            {tuple.data.logoUrl && (
              <LogoBox>
                <img src={tuple.data.logoUrl} />
              </LogoBox>
            )}

            <RightContentBox>
              {props.elRightContent}

              <OptionsPopover.FC
                options={[
                  {
                    id: 'settings',
                    elIcon: <Settings />,
                    show: !loading && hasPermission(['store_viewSettings']),
                    label: "Settings"
                  },
                  {
                    id: 'logOut',
                    elIcon: <Logout />,
                    label: "Log Out"
                  }
                ]}
                onClickOption={handleClickOption}
                fnGenButton={handleClick => (
                  <IconButton onClick={handleClick}>
                    <MoreVert />
                  </IconButton>
                )} />
            </RightContentBox>
          </Toolbar>
        </AppBar>

        <ChildBox>
          {props.children}
        </ChildBox>
      </BaseActivityTemplate.FC>
    </StoreThemeProvider.FC>
  );
};
